import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    iconComponent: { name: 'cil-speedometer' },
    badge: {
      color: 'info',
      text: 'NEW'
    }
  },
  {
    name: 'Components',
    title: true
  },
  
  
  {
    name: 'eLLMo - Gen AI',
    iconComponent: { name: 'cil-memory' },
    url: '/generative-ai/ellmo',
    children: [

    ],
        badge: {
          color: 'success',
          text: 'PRO'
        },
  },  
  {
    name: 'Translation',
    url: '/translation',
    iconComponent: { name: 'cil-language' },
    children: [
      {
        name: 'Text Translation',
        url: '/translation/text-translation',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Rich Text Translation',
        url: '/translation/rich-text-translation',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Transliteration',
        url: '/translation/transliteration',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Document Translation',
        url: '/translation/document-translation',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Audio Translation',
        url: '/translation/speech-translation',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Video Translation',
        url: '/translation/video-translation',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Live Translation',
        url: '/translation/live-translation',
        icon: 'nav-icon-bullet'
      }
    ]
  },
  {
    name: 'Transcription',
    url: '/transcription-speech-to-text',
    iconComponent: { name: 'cil-speech' },
    children: [
      {
        name: 'Live Transcription',
        url: '/transcription-speech-to-text/live-transcription',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Video Transcription',
        url: '/transcription-speech-to-text/video-transcription',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Audio Transcription',
        url: '/transcription-speech-to-text/audio-transcription',
        icon: 'nav-icon-bullet'
      }
    ]
  },
  {
    name: 'Text to Speech',
    url: '/text-to-speech',
    iconComponent: { name: 'cil-voice-over-record' },
    children: [
      {
        name: 'TTS Library',
        url: '/text-to-speech/tts-voice-list',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Voice Cloning',
        url: '/text-to-speech/voice-cloning',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'TTS',
        url: '/text-to-speech/tts',
        icon: 'nav-icon-bullet'
      }
    ]
  },

  
  {
    name: 'Language Detection',
    iconComponent: { name: 'cil-magnifying-glass' },
    url: '/language-detection',
    children: [
      {
        name: 'Text Language Detection',
        url: '/language-detection/text-language-detection',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Speech Language Detection',
        url: '/language-detection/voice-language-detection',
        icon: 'nav-icon-bullet'
      }
    ]
  },
  {
    name: 'Document/Image OCR',
    url: '/optical-character-recognition/document-ocr',
    iconComponent: { name: 'cil-cc' },
    children: [
      
    ]
  },
  {
    title: true,
    name: 'Other Links',
    class: 'mt-auto'
  },
  {
    name: 'Subscribe',
    iconComponent: { name: 'cil-bookmark' },
    url: '/subscribe/purchase-subscription'
  },
  {
    name: 'Genailia Homepage',
    url: 'https://www.genailia.com/',
    iconComponent: { name: 'cil-home' },
    attributes: { target: '_blank' }
  },
  {
    name: 'API Documentation',
    url: 'https://documentation.genailia.com/',
    iconComponent: { name: 'cil-file' },
    attributes: { target: '_blank' }
  },
  {
    name: 'Take a Survey',
    url: 'https://surveys.genailia.com/zs/Nz60jY',
    iconComponent: { name: 'cil-description' },
    attributes: { target: '_blank' }
  }
];

const extraNavItem: INavData = {
  name: 'Purchase Order Extraction',
  url: '/specific-user/poc',
  iconComponent: { name: 'cil-cc' },
};
export function getNavItems(user: any): INavData[] {
  const normaItems = [...navItems];
  const ocrIndex = normaItems.findIndex(item => item.url === '/optical-character-recognition/document-ocr');
  console.log('user is '+user);
  if (user === 'karbook98@gmail.com' || user === 'hellovharvest@gmail.com') {
    if (ocrIndex !== -1) {
      normaItems.splice(ocrIndex + 1, 0, extraNavItem);
    }
  }

  return normaItems;
}